import { render, staticRenderFns } from "./vip-company-choose.vue?vue&type=template&id=53f937ce&scoped=true"
import script from "./vip-company-choose.vue?vue&type=script&lang=js"
export * from "./vip-company-choose.vue?vue&type=script&lang=js"
import style0 from "./vip-company-choose.vue?vue&type=style&index=0&id=53f937ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f937ce",
  null
  
)

export default component.exports